import { Link, NavLink } from "react-router-dom";

import taramIconLogo from "../../assets/icons/taramlogo.png";

import { ChevronLeftIcon, TaramLogo } from "../../components/Icons";

import VTabBarLink from "./VTabBarLink";
import Tour from "./Tour";

import { RoutesType, LinkProps } from "../../layout/VTabBarLayout";
import { useAppContext } from "../../context/AppContext";
import { useEffect } from "react";

type BottomLinks = Omit<LinkProps, "id" | "content" | "disabled">;

export default function SideNavbar({
  routes,
  bottomLinks,
}: {
  routes: RoutesType;
  bottomLinks: BottomLinks[];
}) {
  const { userLoading, user } = useAppContext();

  const toggleSidebarOnExpand = () => {
    const sidebarEl = document.querySelector("#sidebar");

    if (!sidebarEl) return;

    const sidebarIsCollapsed = sidebarEl.classList.contains("w-[90px]");

    // ❗ Do NOT toggle if already collapsed
    if (sidebarIsCollapsed) return;

    toggleSidebar();
  };

  const toggleSidebar = () => {
    const sidebarEl = document.querySelector("#sidebar");
    const mainContextEl = document.querySelector(".main_content");
    const dashboardNavbarEl = document.querySelector("#dashboard_navbar");
    const arrowIconEl = document.querySelector("#arrow_icon");
    const fullLogoEl = document.querySelector(".full_logo");
    const iconLogoEl = document.querySelector(".icon_logo");
    const mainOutletEl = document.querySelector("#main_content_outlet");
    const dashboardNavbarContainerEl = document.querySelector(
      "#dashboard_navbar_container",
    );

    fullLogoEl?.classList.toggle("collapsed");
    iconLogoEl?.classList.toggle("collapsed");

    arrowIconEl?.classList.toggle("rotate-180");

    sidebarEl?.classList.toggle("w-[90px]");
    sidebarEl?.classList.toggle("w-[264px]");

    dashboardNavbarEl?.classList.toggle("ml-[90px]");
    dashboardNavbarEl?.classList.toggle("ml-[264px]");
    mainContextEl?.classList.toggle("ml-[90px]");
    mainContextEl?.classList.toggle("ml-[264px]");

    document.querySelectorAll(".sidebar_label")?.forEach((el) => {
      el.classList.toggle("collapse");
    });

    dashboardNavbarContainerEl?.classList.toggle("max-w-[1200px]");
    mainOutletEl?.classList.toggle("max-w-[1200px]");
  };

  useEffect(() => {
    window.addEventListener("expand-dealtracker-table", toggleSidebarOnExpand);
    return () =>
      window.removeEventListener(
        "expand-dealtracker-table",
        toggleSidebarOnExpand,
      );
  }, []);

  return (
    <aside
      className="w-[264px] h-full fixed top-0 z-40 border border-r-[#D8D8D8] bg-[#EAECF0] px-4 pt-8 pb-2 flex flex-col justify-between transition-all duration-300"
      id="sidebar"
    >
      <button
        type="button"
        className="absolute -right-4 cursor-pointer bg-white text-custom-dark-blue-new w-8 h-8 flex justify-center items-center rounded-full"
        onClick={toggleSidebar}
      >
        <ChevronLeftIcon
          className="size-5 transition-transform duration-300 ease-in-out"
          strokeWidth={2.5}
          id="arrow_icon"
        />
      </button>

      <div>
        <div className="mb-10 px-4 h-[20px]">
          <Link to={"/"}>
            <TaramLogo className="max-w-[127px] w-full full_logo" />
            <img
              src={taramIconLogo}
              alt="logo"
              width={30}
              height={20}
              className="icon_logo"
            />
          </Link>
        </div>

        {userLoading ? (
          <div className="space-y-4">
            {[...Array(4)].map((_, i) => (
              <SideNavbarSkeleton key={i} />
            ))}
          </div>
        ) : (
          routes.map((el) => <VTabBarLink key={el.id} el={el} />)
        )}
      </div>

      <div className="text-custom-dark-blue-new">
        <Tour />

        {bottomLinks.map((el) => (
          <NavLink
            key={el.name}
            to={el.route}
            className={({ isActive }) =>
              `px-4 flex items-center gap-3 py-[10px] text-custom-dark-blue-new ${
                isActive ? "bg-custom-highlight-white rounded-2xl" : ""
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={`relative ${
                    isActive ? "text-custom-dark-blue-new" : "text-black/50"
                  }`}
                >
                  {el.icon}
                  {el.name === "Business Info" && user?.status === null && (
                    <span className="absolute top-0 flex size-2">
                      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75"></span>
                      <span className="relative inline-flex size-2 rounded-full bg-orange-500"></span>
                    </span>
                  )}
                </span>
                <span className="sidebar_label">{el.name}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </aside>
  );
}

function SideNavbarSkeleton() {
  return (
    <div className="animate-pulse rounded-xl bg-slate-300 h-[40px] w-full"></div>
  );
}
